import url from './url';



export default url(({ presetId = ':presetId' }) => `/presets/${presetId}/edit`);
